export const operations = ["sum", "subtraction", "multiplication", "division", "percentage"];
export const levels = ["beginner", "advanced", "expert", "master", "grandmaster"];
export const colors = ["purple", "blue", "green", "yellow", "orange"];
